import { Button, Card, CircularProgress, Stack, Typography } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { createSocialOrderFormSchema } from '../ZodValidationSchema'
import type { CreateSocialOrderFormValues } from '../ZodValidationSchema'
import { FormBlock } from '../../../../common/FormGenerator'
import { getFormConfig } from './settingsConfig'
import { CardStyle, TypStyle } from './style'

type DraftSocialOrderFormProps = {
  onSubmitDraft: (data: CreateSocialOrderFormValues) => void
  isLoading: boolean
}

export const DraftSocialOrderForm = ({ onSubmitDraft, isLoading }: DraftSocialOrderFormProps) => {
  const methods = useForm<CreateSocialOrderFormValues>({
    mode: 'onBlur',
    resolver: zodResolver(createSocialOrderFormSchema),
    defaultValues: {
      title: '',
      description: '',
      problem: '',
      focus: [],
      image: '',
    },
  })

  const { handleSubmit } = methods

  return (
    <Stack alignItems="center" pt={{ xs: '15px', md: '50px' }} px={1.5}>
      <FormProvider {...methods}>
        <Stack gap={2} maxWidth={{ xs: "736px", md: "840px" }} width="100%">
          <Typography variant="h1" px={{ xs: 0, md: 2.5 }}>
            Создание социального заказа
          </Typography>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Изображение
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('image')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Название
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('title')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Описание
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('description')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Проблема, которую решает социальный заказ
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('problem')} />
          </Card>
          <Card variant="primaryAdaptiveCard" sx={CardStyle}>
            <Typography variant="black-16-semiBold" component="div" sx={TypStyle}>
              Направленность
            </Typography>
            <FormBlock formFieldConfig={getFormConfig('focus')} />
          </Card>

          <Stack direction="row" spacing={1}>
            <Button
              variant="action"
              onClick={handleSubmit(onSubmitDraft)}
              disabled={isLoading}
            >
              {isLoading ? (
                <Stack direction="row" alignItems="center" spacing={1}>
                  <CircularProgress size={16} color="inherit" />
                  <span>Сохранение...</span>
                </Stack>
              ) : (
                'Создать'
              )}
            </Button>
          </Stack>
        </Stack>
      </FormProvider>
    </Stack>
  )
}
